import styled from "styled-components";

export const ContentContainer = styled.div`
	height: 100%;
	width: 80%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	margin-top: 200px;

	@media screen and (max-width: 1024px) {
		width: 70%;
	}
`;

export const TextContent = styled.span`
	font-size: 18px;
	margin: 0;
	padding: 0;
	text-align: center;
	line-height: 30px;
`;

export const TitleText = styled.span`
	font-size: 30px;
	font-weight: bold;
	text-align: center;
`;
export const PageContainer = styled.div`
	width: 100%;
	height: 100%;
`;
